import React, {Component} from 'react';
import axios from "axios/index";

export default class Vcard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data ? this.props.data : this.getExpertDetails(this.props.id)
        };

        this.getExpertDetails = this.getExpertDetails.bind(this);
    }

    getExpertDetails(officeId) {
        axios.get('/api/marineproductsofficesearch/GetContactDetails', {
            params: {
                officeId: officeId
            }
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
        })
        .then(response => {
            if(response.data) {
                this.setState({
                    data: response.data
                });
            }
        });
    }

    render() {
        let vcardContent;

        if(this.state.data) {
            vcardContent = (
                <React.Fragment>
                    <header>
                        <span className="contact-card__icon contact-card__icon--cs" aria-hidden="true"></span>
                        <h4 className="contact-card__name" itemProp="name">
                            <span>
                                {this.state.data.Name}
                            </span>
                        </h4>
                    </header>
                    <ul>
                        <li className="contact-card__item">
                            <h5 className="contact-card__item-title">
                                <span>
                                    Phone:
                                </span>
                            </h5>
                            <a className="contact-card__item-content" href={"tel:" + this.state.data.Phone} itemProp="telephone">
                                {this.state.data.Phone}
                            </a>
                        </li>
                        <li className="contact-card__item">
                            <h5 className="contact-card__item-title">
                                <span>
                                    E-mail:
                                </span>
                            </h5>
                            <a className="contact-card__item-content" href={"mailto:" + this.state.data.Email} itemProp="email">
                                {this.state.data.Email}
                            </a>
                        </li>
                    </ul>
                    <a href={this.state.data.Url} className="contact-card__item-link" itemProp="url">
                        <span>
                            See office details
                        </span>
                    </a>
                </React.Fragment>
            );
        } else {
            vcardContent = (
                <div className="loader--full-screen">
                    <div className="loader__icon"/>
                </div>
            );
        }

        return (
            <address className="contact-card contact-card--small" itemScope itemType="https://schema.org/ContactPoint">
                {vcardContent}
            </address>
        );
    }
}
